﻿$.fn.dxCtrlFichier2LstThumbItem = function custom_dxCtrlFichier2LstThumbItem(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2lstthumbitem dx-ctrl");
        this.createInstance(new cdxCtrlFichier2LstThumbItem(this, option));
    }
    return this;
}

window.cdxCtrlFichier2LstThumbItem = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivElementDefaut = null
    function mConstruit() {
        container.empty();
        if (typeof option.onClick != 'undefined') {
            container.css("cursor", "pointer")
            container.on("click", function (e) { option.onClick(option.itemData) })
        }
        container.css("border-radius", "10px")
        container.css("border", theme.border)
        container.css("margin", "10px 0")
        container.css("position", "relative")
        $("<div/>").appendTo(container).dxCtrlFichier2Thumb({
            bddCtrl: option.bddCtrl,
            urlFile: option.itemData.url
        }).dxCtrlFichier2Thumb("instance")

        var fichier = new cFichier(option.bddCtrl,option.itemData.url)
        var $DivName = $("<div style='position:absolute;width:100%;border-bottom-left-radius:10px;border-bottom-right-radius:10px;bottom:0;left:0;text-overflow:ellipsis;overflow:hidden;background-color:rgba(0,0,0,0.3);padding:0 5px;white-space:nowrap;'>" + fichier.mGetNom() + "</div>").appendTo(container)
        $DivName.attr("title", fichier.mGetNom())
        $DivElementDefaut = $("<div/>").appendTo(container)
    }

    this.element = function () { return container }

    mConstruit();
}